/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type IdleTimeDropdown_idleTimes$ref: FragmentReference;
declare export opaque type IdleTimeDropdown_idleTimes$fragmentType: IdleTimeDropdown_idleTimes$ref;
export type IdleTimeDropdown_idleTimes = $ReadOnlyArray<{|
  +node: ?{|
    +id: string,
    +name: ?string,
    +isInternalTime: ?boolean,
    +disabled: ?boolean,
  |},
  +$refType: IdleTimeDropdown_idleTimes$ref,
|}>;
export type IdleTimeDropdown_idleTimes$data = IdleTimeDropdown_idleTimes;
export type IdleTimeDropdown_idleTimes$key = $ReadOnlyArray<{
  +$data?: IdleTimeDropdown_idleTimes$data,
  +$fragmentRefs: IdleTimeDropdown_idleTimes$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "IdleTimeDropdown_idleTimes",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IdleTime",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInternalTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "disabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IdleTimeTypeEdge"
};
// prettier-ignore
(node/*: any*/).hash = '31106d34a989d8a8b78b1b3d05815e7d';

module.exports = node;
